import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { throttle } from 'throttle-debounce';
import cn from 'classnames';
import Menu from '../Menu/Menu';
import Dropdown from '../Dropdown/Dropdown';
import './NavDropdown.scss';

type Props = {
  title: string;
  titleTag?: string;
  menuSection: {
    items: Array<{
      icon?: React.ReactNode;
      title: string;
      to: string;
      onClick?: () => void;
    }>;
  };
  secondarySections?: Array<{
    items: Array<{
      icon: React.ReactNode;
      title: string;
      to: string;
    }>;
    mods: string;
  }>;
  mods: string;
  mix: string;
};

const NavDropdown: React.FC<Props> = (props) => {
  const {
    title,
    titleTag = 'h2',
    menuSection,
    secondarySections = [],
    // user,
    mods,
    mix,
  } = props;
  const [firstHiddenItemIndex, setFirstHiddenItemIndex] = useState(0);
  const ElementTitle = titleTag;
  const prevWindowWidth = useRef(window.innerWidth);
  const navRef = useRef();
  const prevFirstHiddenItemIndexRef = useRef();
  const counterEffect = useRef(0);
  const location = useLocation();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    setFirstHiddenItemIndex(getAllItemsLength());
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    addResizeListener();

    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return () => removeResizeListener();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // @ts-ignore
    prevFirstHiddenItemIndexRef.current = firstHiddenItemIndex;
  });

  useEffect(() => {
    if (counterEffect.current < 2) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      setFirstHiddenItemIndexMain();
    }

    // eslint-disable-next-line no-plusplus
    counterEffect.current++;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstHiddenItemIndex]);

  useLayoutEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    setFirstHiddenItemIndexMain();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstHiddenItemIndex]);

  function isNavigationOverflowed() {
    // @ts-ignore
    return navRef.current.scrollWidth > navRef.current.clientWidth;
  }

  function getAllItemsLength() {
    let counterItem = 0;
    // eslint-disable-next-line @typescript-eslint/no-shadow,@typescript-eslint/no-use-before-define
    menuSections.forEach((menuSection) => {
      // @ts-ignore
      counterItem += menuSection.items.length;
    });

    return counterItem;
  }

  function showAllItems() {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    prevFirstHiddenItemIndexRef.current !== getAllItemsLength() &&
      setFirstHiddenItemIndex(getAllItemsLength());
  }

  function setFirstHiddenItemIndexMain() {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isNavigationOverflowed() &&
      setFirstHiddenItemIndex((prevFirstHiddenItemIndex) => prevFirstHiddenItemIndex - 1);
  }

  function handleWindowResize() {
    if (window.innerWidth >= 768) {
      if (window.innerWidth < prevWindowWidth.current) {
        setFirstHiddenItemIndexMain();
      } else {
        showAllItems();
        setFirstHiddenItemIndexMain();
      }
    } else {
      showAllItems();
    }

    prevWindowWidth.current = window.innerWidth;
  }

  const handleWindowResizeTrottled = throttle(500, () => {
    handleWindowResize();
  });

  function addResizeListener() {
    window.addEventListener('resize', handleWindowResizeTrottled);
  }

  function removeResizeListener() {
    window.removeEventListener('resize', handleWindowResizeTrottled);
  }

  const menuSections = [menuSection, ...secondarySections];

  function renderMenu(isMenuDropdown = false) {
    let counter = 0;
    const menu = menuSections
      // eslint-disable-next-line @typescript-eslint/no-shadow
      .map((menuSection, index) => {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const menuItems = menuSection.items.filter((item) =>
          // eslint-disable-next-line no-plusplus
          !isMenuDropdown ? counter++ < firstHiddenItemIndex : counter++ >= firstHiddenItemIndex
        );
        // eslint-disable-next-line prefer-const
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-shadow,prefer-const
        let { items, mods = {}, ...rest } = menuSection;

        if (index > 0) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          mods = 'menu_secondary';
        }

        return {
          menuItems,
          mods: cn(!isMenuDropdown ? 'menu_type_main-navigation' : 'menu_type_context'),
          mix: 'main-navigation__menu',
          ...rest,
        };
      })
      .filter((item) => item.menuItems.length > 0);

    // eslint-disable-next-line react/no-array-index-key
    return menu.map((item, index) => <Menu key={index} {...item} />);
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  function highlightButtonDropdown(firstHiddenItemIndex: number) {
    let counter = 0;
    let isHighlighted = false;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    menuSections.forEach((menuSection) => {
      // @ts-ignore
      menuSection.items.forEach((item) => {
        const regexp = new RegExp(`^${item.to}$`);

        if (regexp.test(location.pathname) && counter >= firstHiddenItemIndex) {
          isHighlighted = true;
        }

        // eslint-disable-next-line no-plusplus
        counter++;
      });
    });

    return isHighlighted;
  }

  return (
    <nav
      // @ts-ignore
      ref={navRef}
      className={cn(mods, mix)}
    >
      {
        // @ts-ignore
        title && <ElementTitle className="navigation__title">{title}</ElementTitle>
      }
      <div className="navigation__menu">
        <div className="main-navigation__menu-sections">
          {renderMenu()}
          {firstHiddenItemIndex !== getAllItemsLength() && (
            <div className="main-navigation__dropdown">
              <Dropdown
                className={cn(
                  'main-navigation-chevron',
                  highlightButtonDropdown(firstHiddenItemIndex) &&
                    'main-navigation-chevron_highlighted'
                )}
                toggle={{ text: 'Еще' }}
              >
                {renderMenu(true)}
              </Dropdown>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavDropdown;
